/* jp-track (T34; PAGE_BLUEPRINTS v1.1 §11.2, U08): one dispatcher for the anonymous event dictionary.
   Only dictionary events and whitelisted fields pass; everything else is dropped (no names, emails, IDs, URLs,
   queries, timestamps, file names or text). The name is mapped to justpress:<event>.
   Where events go is not decided yet: the Shopify custom-event channel (Shopify.analytics.publish) needs its own
   approval for privacy consent and reporting, so the live theme sends nothing (the sink is empty). The prototype's
   demo file sets a console sink so the events can be checked. Demo modules never emit. */
(function () {
  'use strict';
  var VERSION = 'jp-anon/1.0-draft';
  var EVENTS = ['page_ready', 'content_link', 'series_topic_view', 'design_select', 'save_action', 'saved_tab', 'set_change', 'size_preview', 'size_confirm', 'placement_confirm', 'map_mode', 'map_state_error', 'tool_start', 'tool_to_start', 'pack_hint', 'recommendation_click', 'tab_select', 'search_result', 'filter_apply', 'ugc_view', 'review_link', 'review_view', 'submission_state', 'gift_state', 'purchased_coverage', 'checkout_state', 'source_render_state', 'support_category', 'module_health'];
  var FIELDS = { page_type: /^P\d{2}$/, feature: /^F\d{2}$/, entry_class: /^(external|series|article|design|library|other)$/, zone_key: /^(wrist|forearm|upperarm|shoulder|fingers|collarbone|chest|ribs|stomach|hip|thigh|ankle|neck|shoulderblade|upperback|spine|lowerback|unknown)$/,
    source_type: /^(library|upload|text|unknown)$/, size_id: /^[a-z0-9-]{1,32}$/, orientation: /^(portrait|landscape|square|unknown)$/, pack_tier: /^(15|36|72|unknown)$/, result: /^[a-z_]{1,24}$/,
    destination_type: /^(series|design|tool|article|pack_reviews|library|help|other)$/, render_mode: /^(3d|static|text)$/, count: /^(0|1-10|11\+|\d{1,3})$/, axis: /^(series|size|ugc)$/, tab: /^(saved|purchased)$/, module: /^[a-z-]{1,24}$/, state: /^(disabled|empty|stale|error|ready)$/ };
  var sink = null, once = {};

  function emit(name, fields) {
    if (EVENTS.indexOf(name) < 0) return false;
    var p = { event_version: VERSION, event_name: name };
    Object.keys(fields || {}).forEach(function (k) { var v = String(fields[k]); if (FIELDS[k] && FIELDS[k].test(v)) p[k] = v; else if (FIELDS[k]) p[k] = 'unknown'; });
    var out = sink || window.JPProtoSink;
    if (!out) return false;
    try { out('justpress:' + name, p); } catch (_) {}
    return true;
  }
  function onceEmit(key, name, fields) { if (once[key]) return; once[key] = 1; emit(name, fields); }

  /* page type from the layout's body classes */
  function pageType() {
    var b = document.body.className;
    if (/\bt-index\b/.test(b)) return 'P01';
    if (/\bs-justpress-seo\b/.test(b)) return 'P03';
    if (/\bt-collection\b/.test(b)) return 'P02';
    if (/\bs-justpress-set\b/.test(b)) return 'P35';
    if (/\bt-product\b/.test(b)) return document.querySelector('.jpk') ? 'P09' : 'P04';
    if (/\bs-justpress-placement-tool\b/.test(b)) return 'P25';
    if (/\bt-article\b/.test(b)) return 'P14';
    if (/\bt-blog\b/.test(b)) return 'P13';
    if (/\bt-search\b/.test(b)) return 'P24';
    if (/\bt-cart\b/.test(b)) return 'P10';
    return 'P00';
  }

  function wire() {
    var pt = pageType();
    onceEmit('ready', 'page_ready', { page_type: pt, entry_class: /\/collections\/[^/]+-temporary-tattoos/.test(document.referrer) ? 'series' : document.referrer.indexOf(location.host) > -1 ? 'other' : 'external' });
    if (pt === 'P25') onceEmit('tool', 'tool_start', { entry_class: 'other' });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a');
      if (!a) return;
      if (a.classList.contains('rvl')) emit('review_link', { destination_type: 'pack_reviews', page_type: pt });
      else if (a.closest('.jp-product-similar')) emit('recommendation_click', { result: 'design' });
      else if (a.closest('.jp-ser-more')) emit('recommendation_click', { result: 'related_style' });
      else if (a.closest('.itxa, .jp-topic')) emit('content_link', { destination_type: /\/products\//.test(a.pathname) ? 'design' : /\/collections\//.test(a.pathname) ? 'series' : 'other', page_type: pt });
    }, true);
    document.addEventListener('justpress:module', function (e) {
      var n = e.detail && e.detail.name;
      if (n === 'series-ugc' || n === 'design-ugc') emit('ugc_view', { result: 'ready' });
      emit('module_health', { module: n, state: 'ready' });
    });
    document.addEventListener('justpress:set-change', function () { emit('set_change', { result: 'success' }); });
    document.addEventListener('justpress:saved-change', function (e) { emit('save_action', { result: e.detail && e.detail.saved === false ? 'remove' : 'add' }); });
  }

  window.JPTrack = { emit: emit, setSink: function (fn) { sink = typeof fn === 'function' ? fn : null; } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire); else wire();
})();
